import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Domain, SitemapQueryKeys } from '@/modules/Domains';

export const useGetAllSitemapQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<WithPagination<Pick<Domain, 'id' | 'name'>>, QueryError>([SitemapQueryKeys.GetAllDomains, siteId, paginationOptions], async () => {
    const { data } = await apiExecutor.get(ApiRoutes.Sitemap.replace(':siteId', siteId), {
      params: paginationOptions
    });
    return data;
  });

export const useGetByIdSitemapQuery = (siteId: string, domainId: string) =>
  buildQuery<
    Pick<Domain, 'id' | 'sitemap' | 'sitemapLastGeneratedAt'>,
    QueryError
  >([SitemapQueryKeys.GetById, siteId, domainId], async () => {
    const { data } = await apiExecutor.get(ApiRoutes.SitemapById.replace(':siteId', siteId).replace(':domainId', domainId));
    return data;
  });

export const useGenerateSitemapMutation = (siteId: string, domainId: string) =>
  buildMutation<void, QueryError, void>(
    [SitemapQueryKeys.Generate, siteId, domainId],
    async () => {
      await apiExecutor.post<void>(ApiRoutes.SitemapByIdGenerate.replace(':siteId', siteId).replace(':domainId', domainId));
    }
  );
